export default __webpack_public_path__ + "static/media/FiveS.2b29902c90b1098091bb2cb445be46e1.webp";